export default __webpack_public_path__ + "static/media/parchmentClosed_Streamer.893e51b9.png";